export default (medium: string) => `utm_source=bridebook&utm_medium=${medium}`;
